import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { chat as defaultChat } from '../../../theme/tokens/semantic';
import { shadows as defaultShadows } from '../../../theme/tokens/shadows';
import { createBusinessFunctionsSx } from '../styles/businessFunctionsLayout';

export default function useBusinessFunctionsSx() {
  const theme = useTheme();

  return useMemo(() => {
    const chat = theme.palette?.chat ?? defaultChat;
    const accent = {
      primary: chat.primary,
      primaryDark: chat.primaryDark,
      primaryMuted: chat.primaryMuted,
      primaryBorder: chat.primaryBorder,
      primaryContrast: chat.primaryContrast,
      divider: chat.divider ?? theme.palette?.divider,
      textPrimary: chat.textPrimary,
      textSecondary: chat.textSecondary,
      textMuted: chat.textMuted,
    };

    return createBusinessFunctionsSx({
      accent,
      shadows: theme.customTokens?.shadows ?? defaultShadows,
    });
  }, [theme]);
}
